module.exports = __webpack_public_path__ + "static/media/mshtml_32543.f5f6d08b.ico";